import { Modal } from 'bootstrap';
import CheckAll from './components/CheckAll';
import ConfirmClick from './components/ConfirmClick';
import DateTimePicker from './components/DateTimePicker';
import Editor from './components/Editor';
import MultiSelect from './components/MultiSelect';
import OpenInNewWindow from './components/OpenInNewWindow';
import Swal from 'sweetalert2';
import Tooltip from './components/Tooltip';
import Chart from 'chart.js';
import ScheduleEntry from './components/ScheduleEntry';
import HttpClient from './components/HttpClient';
import TaskManager from './components/TaskManager';
import ContactSelector from './components/ContactSelector';
import { createApp, defineAsyncComponent } from 'vue';
import Dropzone from 'dropzone';
import './plugins/dayjs';
import { ZiggyVue } from 'ziggy-js';

window.Dropzone = Dropzone;
window.Chart = Chart;
window.Bootstrap = {
    Modal: Modal,
};
window.HttpClient = new HttpClient();
window.Swal = Swal;
window.confirmClick = function (element) {
    Swal
        .fire({
            title: element.getAttribute('title') !== ''
                ? element.getAttribute('title')
                : element.dataset.bsOriginalTitle,
            text: element.dataset.message,
            icon: element.dataset.icon ?? 'warning',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: '<i class="bi bi-hand-thumbs-up me-2"></i>Doorgaan',
            cancelButtonText: '<i class="bi bi-hand-thumbs-down me-2"></i>Annuleren',
        })
        .then((result) => {
            if (result.isConfirmed) {
                if (element.tagName === 'BUTTON') {
                    let form = element.closest('form');

                    if (form) {
                        form.submit();
                        return;
                    }
                }

                window.location = element.getAttribute('href');
            }
        });
};

document.addEventListener('DOMContentLoaded', function () {
    CheckAll.initAll('.js-check-parent');
    ConfirmClick.initAll('.js-confirm');
    DateTimePicker.initAll('.js-datepicker');
    DateTimePicker.initAll('.js-datetimepicker', true);
    Editor.initAll('.js-editor');
    MultiSelect.initAll('.js-selectpicker');
    OpenInNewWindow.initAll('.js-popup');
    Tooltip.initAll('[data-bs-toggle="tooltip"]');
    ScheduleEntry.initAll('.js-activity-modal, .js-comment-modal');
    TaskManager.initAll('.js-task-manager');
    ContactSelector.initAll('.js-contact-selector');

    document.querySelectorAll('.js-report').forEach(function (element) {
        element.addEventListener('click', function (event) {
            event.preventDefault();

            let form = document.querySelector('#filter_form');
            form.setAttribute('action', element.getAttribute('href'));
            form.setAttribute('target', '_blank');
            form.submit();
        });
    });

    document.querySelectorAll('.js-stop-time-tracker').forEach(function (element) {
        let timeTrackerForm = document.querySelector('#time-tracker-form');

        element.addEventListener('click', async function (event) {
            event.preventDefault();

            timeTrackerForm.setAttribute('action', element.getAttribute('href'));
            timeTrackerForm.submit();
        });
    });

    document.querySelectorAll('.js-stop-time-tracker-with-summary').forEach(function (element) {
        element.addEventListener('click', async function (event) {
            event.preventDefault();

            let timeTrackerForm = document.querySelector('#time-tracker-form');
            let summaryField = document.querySelector('#time-tracker-summary');
            let target = element.getAttribute('href');

            let { value: summary } = await Swal.fire({
                inputLabel: 'Provide a summary',
                input: 'textarea',
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: '<i class="bi bi-hand-thumbs-up me-2"></i>Doorgaan',
                cancelButtonText: '<i class="bi bi-hand-thumbs-down me-2"></i>Annuleren',
            });

            if (summary) {
                summaryField.value = summary;
                timeTrackerForm.setAttribute('action', target);
                timeTrackerForm.submit();
            }
        });
    });

    document.querySelectorAll('.pagination-submit a').forEach(function (element) {
        let page = document.querySelector('#page');
        let form = document.querySelector('#filter_form');

        element.addEventListener('click', function (event) {
            event.preventDefault();

            let href = element.getAttribute('href');
            let pageExp = new RegExp('page=([0-9]+)');
            let pageResult = pageExp.exec(href);

            page.value = pageResult[1];
            form.submit();
        });
    });

    document.querySelectorAll('.js-month-nav').forEach(function (element) {
        let form = document.querySelector('#filter_form');

        element.addEventListener('click', function (event) {
            event.preventDefault();

            let month = element.dataset.month;
            let year = element.dataset.year;

            document.querySelector('#filter_month').value = month;
            document.querySelector('#filter_year').value = year;
            document.querySelector('#filter_show_past').checked = element.dataset.past === 'true';

            form.submit();
        });
    });
});

if (document.getElementById('vueTable')) {
    createApp({})
        .use(ZiggyVue)
        .component('r4s-rental-reservations-table', defineAsyncComponent(() => import('./vue-components/RentalReservationsTable/RentalReservationsTable.vue')))
        .component('r4s-activity-reservations-table', defineAsyncComponent(() => import('./vue-components/ActivityReservationsTable/ActivityReservationsTable.vue')))
        .component('r4s-contact-requests-table', defineAsyncComponent(() => import('./vue-components/ContactRequestsTable/ContactRequestsTable.vue')))
        .mount('#vueTable');
}

if (document.getElementById('rentalReservationPage')) {
    createApp({})
        .use(ZiggyVue)
        .component('r4s-rental-reservation-page', defineAsyncComponent(() => import('./vue-components/RentalReservationPage/RentalReservationPage.vue')))
        .component('r4s-rental-reservation-user-dropdown', defineAsyncComponent(() => import('./vue-components/RentalReservationPage/RentalReservationPageChangeUserDropdown.vue')))
        .component('r4s-notes', defineAsyncComponent(() => import('./vue-components/NotesComponent/NotesComponent.vue')))
        .mount('#rentalReservationPage');
}

if (document.getElementById('conceptSchedule')) {
    createApp({})
        .use(ZiggyVue)
        .component('r4s-concept-schedule', defineAsyncComponent(() => import('./vue-components/ConceptSchedule/ConceptSchedule.vue')))
        .mount('#conceptSchedule');
}
